global.tracking = (function ($) {
	function init() {
		trackGraphBlockDownloads();
		trackRiksbankenPlayEvent();
	}

	function trackEvent(data) {
		if (window.dataLayer) {
			window.dataLayer.push(data);
		}
	}

	function trackPageView(url, title) {
		var trackingData = {
			'event': 'VirtualPageView',
			'virtualPageUrl': url,
            'virtualPageTitle': title
		};

		trackEvent(trackingData);
	}

	function trackGraphBlockDownloads() {
		jQuery(document).on('click', '.amcharts-amexport-clickable', function () {
			var data = {
				'event': 'DownloadGraph',
				'chartTitle': $(this).closest('.graph-block').data('chartname'),
				'fileType': $(this).text()
			};
			trackEvent(data);
		});
	}

	function trackRiksbankenPlayEvent() {
		jQuery('.js-ga-tracking-rb-play-event').bind('click', '.js-ga-tracking-rb-play-event', function () {
			var text = $(this).find('.js-ga-tracking-rb-play-event-name').text().trim();

			var data = {
				'event': 'ClickOnVideoTeaser',
				'videoTitle': text
			};

			trackEvent(data);
		});
	}

	init();

	return {
		init: init,
		trackEvent: trackEvent,
		trackPageView: trackPageView
	};
})(jQuery);
